import LeaveRequest from "./leave_request.js";
import CodeLeaveType from "./code_leave_type.js";
import BlockOutDate from "./block_out_date.js";
// import CodeLeaveStatus from "./code_leave_status.js";
import CodeDepot from "./code_depot.js";
import CodeEmployeeType from "./code_employee_type.js";
import Employee from "./employee.js";
import LeaveLimit from "./leave_limit.js";
import EmployeeManager from "./employee_manager.js";
import LeaveRequestType from "./leave_request_type.js";
import LeaveRequestTask from "./leave_request_task.js";
import CodeEmployeeCategory from "./code_employee_category.js";
import DocumentNotificationRule from "./document_notification_rule.js";
import VolunteerShift from "./volunteer_shift.js";

import News from "../../news/schema/index";
import NotificationSchema from "../../vue-notifications/schema/index";
import DMSSchema from "../../vue-dms/schema/index";
import FormSchema from "../../vue-forms247/app/schema";

import { default as PermissionSchema } from "@/vue-ocom/grouppermissions/schema/index.js";
import CheckIn from "./check_in";

export default {
  LeaveRequest,
  CodeLeaveType,
  BlockOutDate,
  // CodeLeaveStatus,
  CodeDepot,
  CodeEmployeeType,
  Employee,
  LeaveLimit,
  EmployeeManager,
  LeaveRequestType,
  LeaveRequestTask,
  CodeEmployeeCategory,
  DocumentNotificationRule,
  VolunteerShift,

  ...News,
  ...NotificationSchema,
  ...PermissionSchema /* For Schema */,
  ...DMSSchema /* For Dms */,
  ...FormSchema,
  CheckIn,
};
